/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

 import store from '@/store/index';
 import ProductApis from '@/controllers/ProductApis';
 import ApiHelper from '@/controllers/ApiHelpers';
 import router from '@/router';


 export default {
    /**
      * Fetch all products with location
      */
    fetchAllProduct(params, data) {
        const location = store.getters['location/selected']
        const url = `product/inventoryManagementView/${location.id}${params?'?'+params:''}`;
        return ProductApis.postApi(url, null, data)
          .then(res => res)
          .catch(err => {
            ApiHelper.detectStatusAndRedirect(err);
            return err;
          });
    }
}